import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { json, Link, useLoaderData, useNavigate } from 'react-router-dom';
import { RadioGroup, FormControlLabel, Radio, Alert } from '@mui/material';
import intl from 'react-intl-universal';
import { Routes } from '../Routes';
import Copyright from '../components/Copyright';
import MaskedTextField from '../components/MaskedTextField';
import { useState } from 'react';
import Validate from '../utils/Validate';
import UserService from '../services/UserService';


export async function ResetPasswordLoader ({ params }) {
  const data = { companyName: params.companyName };
  return json(data, { status: 200 });
}

 
export default function ResetPassword() {
  const data = useLoaderData();	
  const navigate = useNavigate();

  const [otpMethod, setOtpMethod] = useState('email');
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit(event){
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const stateData = Object.fromEntries(formData.entries());
    
    if (!Validate.email(stateData.email)) {
      setErrorMessage(intl.get("invalidemailformat").d("Invalid email format.") );
      return;
    }
    
    if (!Validate.phone(stateData.phone)) {
      setErrorMessage(intl.get("invalidphone").d("Invalid phone.") );
      return;
    }
    
    const emailExist = await UserService.emailExists(stateData.email);
    if( emailExist === undefined || !emailExist.ok ){
 	  setErrorMessage(intl.get("erroroccurredvalidatingemail").d("Error occurred validating email.") );
      return;			
	}
	
    if( emailExist && emailExist.ok && emailExist.exists === false ){
 	  setErrorMessage(intl.get("thiemailisnotregistered").d("This email is not registered.") );
      return;			
	}
    
    const phoneExist = await UserService.phoneExists(stateData.phone);
    if( phoneExist === undefined || !phoneExist.ok){
 	  setErrorMessage(intl.get("erroroccurredvalidatingphone").d("Error occurred validating phone.") );
      return;			
	}
	
    if( phoneExist === undefined && phoneExist.ok && phoneExist.exists === false){
 	  setErrorMessage(intl.get("thisphoneisnotregistered").d("This phone number is not registered.") );
      return;			
	}
    
    setErrorMessage("");
    
    // set next page for OTP
    stateData.nextPath = Routes.signIn + (stateData.companyName ? "/" + stateData.companyName : "");
    stateData.message = intl.get("loginwithpasswordsent").d("Log in with the password that was sent to you.");
    navigate(Routes.sendOtp, { state: stateData });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {intl.get('resetpassword').d('Reset password')}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Typography component="p" variant="caption">
            {intl
              .get('selectwhereyouwouldliketoreceive...')
              .d(
                'Select where to receive your one-time passcode. Ensure the phone number or email is linked to your account.'
              )}
          </Typography>

          {/* Radio Group for Selecting OTP Method */}
          <RadioGroup
            row
            value={otpMethod}
            onChange={(e) => {
              setOtpMethod(e.target.value);
            }}
          >
            <FormControlLabel
              value="email"
              control={<Radio />}
              label={intl.get('emailaddress').d('Email address')}
            />
            <FormControlLabel
              value="phone"
              control={<Radio />}
              label={intl.get('mobilephone').d('Mobile phone')}
            />
          </RadioGroup>

          {/* Conditionally Render Email or Phone Field */}
          {otpMethod === 'email' ? (
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={intl.get('emailaddress').d('Email address')}
              name="email"
              autoComplete="email"
              autoFocus
            />
          ) : (
            <MaskedTextField
              mask="(999) 999-9999"
              alwaysShowMask={false}
              required
              fullWidth
              id="phone"
              name="phone"
              label={intl.get('mobilephone').d('Mobile phone')}
              autoComplete="tel-national"
            />
          )}

		  <div hidden={!!data.companyName}>
		    <TextField
		      readOnly={!!data.companyName}
		      margin="normal"
		      required
		      fullWidth
		      name="companyName"
		      id="companyName"
		      label={intl.get('company').d('Company')}
		      type={data.companyName ? 'hidden' : 'text'}
		      defaultValue={data.companyName ? data.companyName : ''}
		    />	 
		  </div>  

          {errorMessage && (

              <Alert severity="error">{errorMessage}</Alert>
          )}   
              				  
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {intl.get('signin').d('Sign In')}
          </Button>
          <Grid container>
            <Grid item>
              <Link to={Routes.createAccount} variant="body2">
                {intl
                  .get('donthaveanaccountsignup')
                  .d("Don't have an account? Sign Up")}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}
